// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3qIWJ","container":"styles_container__3sho6","title":"styles_title__2RwMV","wrapper":"styles_wrapper__2evBW","answer":"styles_answer__3ognq"};